import React from "react";
import c from "classnames";
import moment from "moment";
import PulseLoader from "react-spinners/PulseLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "react-loading-skeleton";

import { getLocation } from "../util/url";

import theme from "../theme.js";

import css from "./block.module.scss";

const DateBlock = ({ style, className, event }) => {
  return (
    <div className={c("w-100 d-flex mt-3 bg-white border", css["db-wrapper"], className)} style={style}>
      <div className="d-flex align-self-stretch p-3 bg-success text-center">
        <div className="align-self-center text-white">
          {event && (
            <>
              <span>{moment(event.start).format("MMM").split(".")[0]}</span>
              <br />
              <span className="pt-1">{moment(event.start).format("D")}</span>
            </>
          )}
        </div>
      </div>
      <div className="align-self-center flex-fill p-2 text-dark" style={{ minWidth: 0, minHeight: 0, overflow: "hidden" }}>
        {event ? (
          <>
            <h3 className="h5" dangerouslySetInnerHTML={{ __html: event.title }} />
            {event.venue && event.venue.city && (
              <div className="mt-2 d-flex">
                <FontAwesomeIcon icon="map-marker" size="xs" />
                <span className="ml-2">
                  {event.venue.address}, {event.venue.zip} {event.venue.city}
                </span>
              </div>
            )}
            <div className="mt-1">
              <a href={getLocation(event.url)}>
                <strong>Zur Veranstaltung</strong>
              </a>
            </div>
          </>
        ) : (
          <Skeleton count={3} />
        )}
      </div>
    </div>
  );
};

export default DateBlock;
